import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center px-6 py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900" data-id="element-120">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1920&q=80')] bg-cover bg-center opacity-10" data-id="element-121"></div>

      <div className="relative max-w-5xl mx-auto text-center" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-123">
          <img src="https://i.postimg.cc/rzHh7hJL/Enlaces-logo-white.png" alt="Enlaces Consultora" className="h-32 mx-auto mb-8" data-id="element-124" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-125">
          Donde el talento encuentra su lugar
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-xl md:text-2xl text-slate-300 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-126">
          Somos un equipo de Lic. en psicología especializadas en la selección
          de personal: reclutamos, acompañamos e incorporamos el mejor capital
          humano para tu empresa
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-127">
          <a href="#contacto" className="group inline-flex items-center justify-center px-8 py-4 bg-emerald-500 text-white font-semibold rounded-lg hover:bg-emerald-600 transition-all duration-300 hover:scale-105" data-id="element-128">
            Busco talento
            <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-129" />
          </a>

          <a href="#empleo" className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg border-2 border-white/30 hover:bg-white/20 transition-all duration-300" data-id="element-130">
            Busco empleo
          </a>
        </motion.div>
      </div>
    </section>;
}